enum MyWebsiteV3MastheadAlignmentHorizontal {
    Centre,
    Left,
    Right
}

export default MyWebsiteV3MastheadAlignmentHorizontal
